import * as React from 'react';
import { AccordionContextProps, AccordionContext } from './context';
import * as S from './styles';
import { DesAccordionProps } from './DesAccordion.types';

const DesAccordion: React.FC<DesAccordionProps> = ({
  styles = {},
  children,
  onSectionToggle,
  enableSingleSectionOpen,
  initialState = {},
  keepSectionContentsInDom,
}) => {
  const [openSections, setOpenSections] =
    React.useState<AccordionContextProps['openSections']>(initialState);

  const handleSectionToggle = (name: string) => {
    setOpenSections({
      ...(enableSingleSectionOpen ? {} : openSections),
      [name]: !openSections[name],
    });

    if (onSectionToggle) {
      onSectionToggle(name, !openSections[name]);
    }
  };

  return (
    <AccordionContext.Provider
      value={{
        openSections,
        handleSectionToggle,
        keepSectionsInDom: keepSectionContentsInDom,
      }}
    >
      <S.AccordionDiv data-component="Accordion" {...styles.root}>
        {children}
      </S.AccordionDiv>
    </AccordionContext.Provider>
  );
};

export default DesAccordion;
